{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Japanese-speaking clinical research professional before activating locale=ja in production.",
  "app": {
    "name": "OneVerse",
    "loading": "読み込み中...",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "confirm": "確認",
    "submit": "送信",
    "edit": "編集",
    "close": "閉じる",
    "back": "戻る",
    "next": "次へ",
    "search": "検索",
    "filter": "絞り込み",
    "export": "エクスポート",
    "yes": "はい",
    "no": "いいえ",
    "required": "必須",
    "optional": "任意",
    "none": "なし",
    "unknown": "不明",
    "error": "エラーが発生しました。再度お試しください。",
    "powered_by": "{{name}} が提供"
  },
  "nav": {
    "home": "ホーム",
    "dashboard": "ダッシュボード",
    "submissions": "申請",
    "studies": "治験",
    "sites": "施設",
    "users": "ユーザー",
    "settings": "設定",
    "notifications": "通知",
    "admin": "管理",
    "help": "ヘルプ",
    "sign_out": "サインアウト",
    "logout": "ログアウト",
    "expand_sidebar": "サイドバーを展開",
    "collapse_sidebar": "サイドバーを折りたたむ"
  },
  "auth": {
    "sign_in": "サインイン",
    "sign_in_button": "サインイン",
    "sign_out": "サインアウト",
    "email": "メールアドレス",
    "email_placeholder": "メールアドレスを入力",
    "password": "パスワード",
    "password_placeholder": "パスワードを入力",
    "forgot_password": "パスワードをお忘れですか？",
    "reset_password": "パスワードをリセット",
    "enter_reset_code": "リセットコードを入力",
    "reset_code_instructions": "メールアドレスを入力すると、パスワードリセット用のコードをお送りします。",
    "new_code_instructions": "コードと新しいパスワードを入力してください。",
    "send_reset_code": "リセットコードを送信",
    "sending": "送信中...",
    "reset_password_action": "パスワードをリセット",
    "resetting": "リセット中...",
    "create_account": "アカウントを作成",
    "welcome": "OneVerseへようこそ",
    "welcome_back": "おかえりなさい",
    "subtitle": "ログイン情報を入力してください。",
    "no_account": "アカウントをお持ちでないですか？",
    "sign_up": "サインアップ",
    "remember_password": "パスワードを覚えていますか？",
    "confirmation_code": "確認コード",
    "confirmation_code_placeholder": "メールまたはSMSのコードを入力",
    "new_password": "新しいパスワード",
    "new_password_placeholder": "新しいパスワードを入力",
    "confirm_password": "パスワードの確認",
    "confirm_password_placeholder": "新しいパスワードを再入力",
    "mfa": {
      "code": "コード",
      "back_to_login": "ログインに戻る",
      "sms_placeholder": "SMSで送信されたコードを入力",
      "email_placeholder": "メールで送信されたコードを入力",
      "totp_placeholder": "認証アプリのコードを入力"
    },
    "show_password": "パスワードを表示",
    "hide_password": "パスワードを非表示",
    "errors": {
      "invalid_credentials": "メールアドレスまたはパスワードが正しくありません。",
      "account_locked": "アカウントがロックされています。サポートにお問い合わせください。",
      "session_expired": "セッションの有効期限が切れました。再度サインインしてください。",
      "email_required": "メールアドレスは必須です",
      "email_password_required": "メールアドレスとパスワードは必須です",
      "all_fields_required": "すべての項目を入力してください",
      "passwords_dont_match": "パスワードが一致しません",
      "unexpected": "予期しないエラーが発生しました",
      "server_non_json": "サーバーから予期しない応答がありました。コンソールを確認してください。"
    }
  },
  "dashboard": {
    "welcome": "ようこそ、{{name}}さん",
    "new_submission": "新規申請",
    "submission_overview": "申請概要",
    "view_all_submissions": "すべての申請を見る",
    "recent_activity": "最近のアクティビティ",
    "no_recent_activities": "最近のアクティビティはありません。",
    "search_placeholder": "検索",
    "total": "合計",
    "submission_singular": "件の申請",
    "submission_plural": "件の申請",
    "active_site_status": "アクティブサイトの状況",
    "view_study": "治験を表示",
    "loading_studies": "読み込み中...",
    "select_study": "治験を選択",
    "view_details": "詳細を表示",
    "news_and_notes": "ニュース＆ノート",
    "no_recent_posts": "最近の投稿はありません。",
    "failed_to_load_announcements": "お知らせの読み込みに失敗しました",
    "statuses": {
      "response_required": "回答必要",
      "drafts": "下書き",
      "submitted": "提出済み",
      "pre_review": "事前審査",
      "irb_review": "IRB審査",
      "post_review": "審査後処理",
      "expiring_soon": "まもなく期限切れ"
    }
  },
  "submissions": {
    "title": "申請一覧",
    "new": "新規申請",
    "empty": "申請が見つかりません。",
    "empty_yet": "申請がまだありません。",
    "search_placeholder": "IDまたはタイトルで検索",
    "filter": {
      "all_statuses": "すべてのステータス",
      "all_types": "すべての種別",
      "status_label": "ステータス",
      "type_label": "種別"
    },
    "errors": {
      "failed_to_load": "申請の読み込みに失敗しました"
    },
    "status": {
      "pending": "保留中",
      "under_review": "審査中",
      "approved": "承認済み",
      "rejected": "却下",
      "revisions_required": "修正要求",
      "withdrawn": "取り下げ",
      "expired": "期限切れ",
      "closed": "終了",
      "draft": "下書き",
      "submitted": "提出済み",
      "pre_review": "事前審査",
      "irb_review": "IRB審査",
      "post_review": "審査後処理",
      "response_required": "回答必要",
      "expiring_soon": "まもなく期限切れ",
      "complete": "完了",
      "deleted": "削除済み"
    },
    "fields": {
      "id": "ID",
      "title": "タイトル",
      "protocol_number": "プロトコル番号",
      "principal_investigator": "治験責任医師",
      "submitted_at": "提出日",
      "submitted": "提出日",
      "updated_at": "最終更新日",
      "expiration": "有効期限",
      "status": "ステータス",
      "type": "種別"
    },
    "actions": {
      "view": "申請を表示",
      "edit": "申請を編集",
      "withdraw": "取り下げ",
      "submit": "審査に提出"
    }
  },
  "studies": {
    "title": "治験一覧",
    "new": "新規治験",
    "empty": "治験が見つかりません。",
    "empty_yet": "治験がまだありません。",
    "search_placeholder": "IDまたはタイトルで検索",
    "filter": {
      "all_statuses": "すべてのステータス",
      "all_types": "すべての種別",
      "type_label": "種別",
      "attribute_label": "属性",
      "all_attributes": "すべての属性",
      "attribute_value_placeholder": "属性の値"
    },
    "errors": {
      "failed_to_load": "治験の読み込みに失敗しました"
    },
    "fields": {
      "id": "ID",
      "title": "治験名",
      "type": "種別",
      "irb_number": "IRB番号",
      "pi": "治験責任医師",
      "status": "ステータス",
      "submitted": "提出日",
      "start_date": "開始日",
      "end_date": "終了日",
      "expiration": "有効期限"
    },
    "standalone": "単独",
    "sort_by": "{{column}}で並べ替え",
    "attributes": {
      "cro": "CRO",
      "sponsor": "スポンサー",
      "pi": "PI",
      "pi_email": "PIメール",
      "poc": "POC",
      "poc_email": "POCメール",
      "poc_phone": "POC電話番号",
      "poc_role": "POC役割"
    }
  },
  "sites": {
    "title": "施設一覧",
    "new": "新規施設",
    "empty": "施設が見つかりません。",
    "empty_yet": "施設がまだありません。",
    "search_placeholder": "ID・施設名・PIで検索",
    "filter": {
      "all_statuses": "すべてのステータス",
      "all_countries": "すべての国",
      "country_label": "国"
    },
    "errors": {
      "failed_to_load": "施設の読み込みに失敗しました"
    },
    "fields": {
      "id": "ID",
      "site_name": "施設名",
      "country": "国",
      "protocol_number": "プロトコル番号",
      "sponsor_name": "スポンサー名",
      "pi_name": "PI名",
      "approved": "承認済み",
      "expiration": "有効期限",
      "status": "ステータス"
    }
  },
  "entity": {
    "status": {
      "in_progress": "進行中",
      "active": "アクティブ",
      "rejected": "却下",
      "suspended": "一時停止",
      "closed": "終了",
      "expired": "期限切れ"
    }
  },
  "activities": {
    "submission_approved": "申請承認",
    "submission_created": "申請作成",
    "submission_submitted": "申請送信",
    "submission_updated": "申請更新",
    "submission_withdrawn": "申請取り下げ",
    "submission_rejected": "申請却下",
    "submission_expired": "申請期限切れ",
    "study_created": "治験作成",
    "study_updated": "治験更新",
    "site_created": "施設作成",
    "site_updated": "施設更新",
    "status_changed": "ステータス変更",
    "review_started": "審査開始",
    "review_completed": "審査完了",
    "comment_added": "コメント追加",
    "document_uploaded": "書類アップロード",
    "response_required": "回答必要"
  },
  "errors": {
    "not_found": "リクエストされたリソースが見つかりませんでした。",
    "unauthorized": "この操作を行う権限がありません。",
    "server_error": "サーバーエラーが発生しました。しばらくしてから再度お試しください。",
    "network_error": "ネットワークエラーが発生しました。接続を確認してください。",
    "not_found_title": "ページが見つかりません",
    "not_found_body": "お探しのページは存在しないか、移動されました。",
    "go_back": "戻る"
  },
  "pagination": {
    "previous": "前へ",
    "next": "次へ",
    "page": "{{total}}ページ中{{current}}ページ",
    "showing": "{{total}}件中{{from}}〜{{to}}件を表示"
  },
  "dates": {
    "today": "今日",
    "yesterday": "昨日",
    "just_now": "たった今",
    "ago": "{{time}}前"
  }
}
